import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const HATCH_DEFS = `
  <defs>
    <pattern id="hatchGreen" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
      <rect width="8" height="8" fill="#22c55e"></rect>
      <line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="3"></line>
    </pattern>
    <pattern id="hatchRed" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
      <rect width="8" height="8" fill="#f87171"></rect>
      <line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="3"></line>
    </pattern>
  </defs>`;

function injectDefsIntoSvgs(root: HTMLElement): () => void {
  const injected: SVGElement[] = [];
  root.querySelectorAll<SVGElement>('svg').forEach(svg => {
    if (!svg.querySelector('#hatchGreen')) {
      svg.insertAdjacentHTML('afterbegin', HATCH_DEFS);
      injected.push(svg);
    }
  });
  return () => injected.forEach(svg => svg.querySelector('defs')?.remove());
}

export async function exportarElemento(
  el: HTMLElement,
  tipo: 'png' | 'pdf',
  nombre: string,
  hideSelectors: string[] = [],
  revealSelectors: string[] = []
): Promise<void> {
  const hidden: HTMLElement[] = [];
  hideSelectors.forEach(s =>
    el.querySelectorAll<HTMLElement>(s).forEach((e: HTMLElement) => hidden.push(e))
  );
  hidden.forEach((e: HTMLElement) => e.style.visibility = 'hidden');

  // Elementos que solo se muestran en el export (ej. texto plano del rango de fechas).
  const revealed: HTMLElement[] = [];
  revealSelectors.forEach(s =>
    el.querySelectorAll<HTMLElement>(s).forEach((e: HTMLElement) => revealed.push(e))
  );
  revealed.forEach((e: HTMLElement) => e.style.display = 'flex');

  const cleanup = injectDefsIntoSvgs(el);
  const canvas = await html2canvas(el, { scale: 2, useCORS: true });
  cleanup();

  revealed.forEach((e: HTMLElement) => e.style.display = '');
  hidden.forEach((e: HTMLElement) => e.style.visibility = '');

  if (tipo === 'png') {
    const link = document.createElement('a');
    link.download = `${nombre}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } else {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: [canvas.width / 2, canvas.height / 2] });
    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width / 2, canvas.height / 2);
    pdf.save(`${nombre}.pdf`);
  }
}
